<template>
  <div class="h-100">
    <transition enter-active-class="animated fadeIn">
      <router-view />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import AppLayout from "./layouts/AppLayout.vue";
export default {
  components: {
    AppLayout,
  },
  async mounted() {
    if (
      this.$cookie.get("g_national_code") &&
      this.$cookie.get("g_mobile") &&
      this.$cookie.get("g_code")
    )
      this.$router.push("/graduate");
    else if (!this.$cookie.get("userToken")) this.$router.push("/login");
    else
      await axios
        .get("b/org/get-user/", {
          headers: { Authorization: "token " + this.$cookie.get("userToken") },
        })
        .then((res) => {
          this.$store.dispatch("setCurrentUser", res.data);
          axios
            .get("b/org/get-summery/", { params: { slug: res.data.slug } })
            .then((res) => this.$store.commit("setSummery", res.data));
        })
        .catch((err) => {
          this.$notify("error", "ورود ناموفق", "لطفا دوباره وارد سامانه شوید");
          this.$cookie.delete("userToken");
          this.$router.push("/login");
        });
  },
  beforeMount() {
    document.body.classList.add("rtl");
    document.dir = "rtl";
  },
};
</script>
